"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import AnimatedButton from "@/components/ui/AnimatedButton";
import Button from "@/components/ui/button";

export default function NotFound() {
    const router = useRouter();
    const pathname = usePathname();
    useEffect(() => {
        // Check if window is defined to ensure this code runs only on the client side
        // if (typeof window !== "undefined") {
        //     // Redirect to the home page
        //     router.push("/");
        // }
        if (pathname !== "/404") {
            return router.push("/404");
        }
    }, [router]);

    // return null;

    return (
        <div
            className="bg-rainbow h-screen flex flex-col justify-center items-center"
            style={{ textAlign: "center", padding: "50px" }}
        >
            <h1 className="text-darkPurple">404 - Page Not Found</h1>
            <p>Sorry, the page you&apos;re looking for does not exist.</p>

            <Button text="Return to Homepage" link="/" className="md:w-1/2" />
        </div>
    );
}
